/**
 * Valid business membership relations for runtime validation
 */
export const VALID_BUSINESS_MEMBERSHIP_RELATIONS = [
    'user',
    'business'
];
/**
 * Type guard to validate business membership relation strings at runtime
 */
export function isValidBusinessMembershipRelation(value) {
    return VALID_BUSINESS_MEMBERSHIP_RELATIONS.includes(value);
}
//# sourceMappingURL=business-membership-include-relation.type.js.map